import { AjaxFormValidation } from '@common/libs/ajax-form-validation';

$(document).ready(() => {
    const $form = $('#MemberRegisterForm'),
        validator = new AjaxFormValidation($form, '/members/ajax_validate', 'v5_register');

    $form.on('blur', 'input:not(:hidden)', (e) => {
        validator.validate(e.target, {}, {
            beforeSend: function() {
                $form.find('[type="submit"]').attr('disabled', true);
            }
        }).always(function(response) {
            $form.find('[type="submit"]').removeAttr('disabled');
        });
    })
    .on('click', '[type="submit"]', (e) => {
        e.preventDefault();
        if (!validator.valid()) {
           return false;
        }
        $(e.currentTarget).attr('disabled', true);
        $form.submit();
    });
});
